import React, { useState, useEffect } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Image, Upload } from "antd";
import MultiImagePicker from "./MultiImagePicker"





const ImagePicker = ({ value, onChange, acceptedFormats = ["image/jpeg", "image/png"], maxFileSize = 10485760 }) => {



    const onMultiImageChange = (images) => {


        if (images.length >= 1) {
            onChange(images[0])
        } else {
            onChange(null);
        }
    }

    return (
        <MultiImagePicker maxPhotos={1} onChange={onMultiImageChange} value={value ? [value] : []}></MultiImagePicker>
    );
};
export default ImagePicker;
